import { format, formatDistanceToNowStrict } from 'date-fns'

export function formatDeal(value: number, digits: number) {
  return value.toFixed(digits)
}

export function formatDate(date: string) {
  return format(new Date(date), 'yyyy/MM/dd HH:mm:ss')
}

export function formatDateWithDayOfWeek(date: string) {
  return format(new Date(date), 'E HH:mm:ss')
}

export function getRemainingTime(date: string | null, minutesConstraints: number) {
  if (date === null) {
    return 0
  }
  const secondsGoneBy = Number(
    formatDistanceToNowStrict(new Date(date), {
      unit: 'second'
    }).split(' ')[0]
  )
  const remainingSeconds = minutesConstraints * 60 - secondsGoneBy
  return Math.max(remainingSeconds, 0)
}

export function formatRemainingTime(time: number) {
  return `${Math.floor(time / 60)
    .toString()
    .padStart(2, '0')}:${(time % 60).toString().padStart(2, '0')}`
}

export function convertToDate(timestamp: number, skipTime?: boolean): string {
  if (!timestamp) {
    return ''
  }

  const datetime = new Date()
  datetime.setTime(timestamp)
  const year = datetime.getFullYear()
  const month = ('0' + (datetime.getMonth() + 1)).slice(-2)
  const day = ('0' + datetime.getDate()).slice(-2)
  let date

  if (!skipTime) {
    const hour = ('0' + datetime.getHours()).slice(-2)
    const minute = ('0' + datetime.getMinutes()).slice(-2)
    const second = ('0' + datetime.getSeconds()).slice(-2)
    date = `${year}/${month}/${day}  ${hour}:${minute}:${second}`
  } else {
    date = `${year}/${month}/${day}`
  }
  return date
}
